import { UserCredential } from "firebase/auth";
import { Dispatch } from "react";
import ActionInterface from "../../Objects/interfaces/ActionInterface";
import Client from "../../Objects/models/Client";
import Teachr from "../../Objects/models/Teachr";
import ImageRepository from "../../Repositories/ImageRepository";
import Teachr_Repository from "../../Repositories/Teachr_Repository";

export const USER_FIREBASE_SET_ACCOUNT = "USER_FIREBASE_SET_ACCOUNT";
export const USER_FIREBASE_UNSET_ACCOUNT = "USER_FIREBASE_UNSET_ACCOUNT";
export const USER_CLIENT_SET_ACCOUNT = "USER_CLIENT_SET_ACCOUNT";
export const USER_CLIENT_UNSET_ACCOUNT = "USER_CLIENT_UNSET_ACCOUNT";
export const USER_TEACHR_SET_ACCOUNT = "USER_TEACHR_SET_ACCOUNT";
export const USER_TEACHR_UNSET_ACCOUNT = "USER_TEACHR_UNSET_ACCOUNT";
export const USER_CURRENT_REGISTER = "USER_CURRENT_REGISTER";
export const USER_CURRENT_PROCURATION = "USER_CURRENT_PROCURATION";
export const USER_PROCURATION = "USER_PROCURATION";
export const USER_FIREBASE_MESSAGING_SET_TOKEN = "USER_FIREBASE_MESSAGING_SET_TOKEN";
export const FETCH_IMAGE_ACTIVE = "FETCH_IMAGE_ACTIVE";
export const GET_URSSAF_TDAE = "GET_URSSAF_TDAE";
export const SET_LOAD = "SET_LOAD";
export const USER_SET_INFO_SIRET = "USER_SET_INFO_SIRET";
export const USER_SET_COOPERATIVE_FORM = "USER_SET_COOPERATIVE_FORM";
export const USER_SET_SAP_FORM = "USER_SET_SAP_FORM";

interface FetchImageProfileAction {
    type: typeof FETCH_IMAGE_ACTIVE;
    value: any;
}
interface GetUrssafTdaeProfileAction {
    type: typeof GET_URSSAF_TDAE;
    value: any;
}
export type FetchImageProfileActionTypes = FetchImageProfileAction;
export type GetUrssafTdaeProfileActionTypes = GetUrssafTdaeProfileAction;



export const userFirebaseSetAccountAction = (
    authMethod: string,
    userCredential: UserCredential | any
): ActionInterface => {
    return {
        type: USER_FIREBASE_SET_ACCOUNT,
        value: { authMethod: authMethod, userCredential: userCredential },
    };
};

export const userFirebaseUnSetAccountAction = (): ActionInterface => {
    return {
        type: USER_FIREBASE_UNSET_ACCOUNT,
        value: null,
    };
};

export const userClientSetAccountAction = (client: Client): ActionInterface => {
    return {
        type: USER_CLIENT_SET_ACCOUNT,
        value: client,
    };
};

export const userClientUnSetAccountAction = (): ActionInterface => {
    return {
        type: USER_CLIENT_UNSET_ACCOUNT,
        value: null,
    };
};

export const userTeachrSetAccountAction = (teachr: Teachr): ActionInterface => {

    return {
        type: USER_TEACHR_SET_ACCOUNT,
        value: teachr,
    };
};

export const userTeachrUnSetAccountAction = (): ActionInterface => {
    return {
        type: USER_TEACHR_UNSET_ACCOUNT,
        value: null,
    };
};

export const userFirebaseMessagingSetToken = (
    token: string
): ActionInterface => {
    return {
        type: USER_FIREBASE_MESSAGING_SET_TOKEN,
        value: token,
    };
};

export const userSetCurrentRegister = (value: number): ActionInterface => {
    return {
        type: USER_CURRENT_REGISTER,
        value: value,
    };
};

export const userSetCurrentProcuration = (value: number): ActionInterface => {
    return {
        type: USER_CURRENT_PROCURATION,
        value: value,
    };
};
export const userSetProcuration = (value: any): ActionInterface => {
    return {
        type: USER_PROCURATION,
        value: value,
    };
};

export const userUnSetCurrentRegister = (): ActionInterface => {
    return {
        type: USER_CURRENT_REGISTER,
        value: 1,
    };
};

export const userUnSetCurrentProcuration = (): ActionInterface => {
    return {
        type: USER_CURRENT_PROCURATION,
        value: 0,
    };
};

export const userSetLoad = (value : {load: boolean, index : number | undefined}): ActionInterface => {
    return {
        type: SET_LOAD,
        value: value,
    };
};

export const userUnSetLoad = (): ActionInterface => {
    return {
        type: SET_LOAD,
        value: null,
    };
};

export const userUnSetCurrentProfile = (): ActionInterface => {
    return {
        type: FETCH_IMAGE_ACTIVE,
        value: null,
    };
};

export const fetchImageProfile = (idPicture: number) => {
    return async (dispatch: Dispatch<FetchImageProfileActionTypes>) => {
        try {
            const image = await ImageRepository.fetchImageById(idPicture);
            dispatch({ type: FETCH_IMAGE_ACTIVE, value: image.contentUrl });
        } catch (error: any) {
            console.error("Erreur lors de la récupération de l'image de profile :", JSON.parse(JSON.stringify(error)));
        }
    };
};

export const getUrssafTdae = (teachrId : number | undefined | null) => {
    return async (dispatch: Dispatch<GetUrssafTdaeProfileActionTypes>) => {
      try {
        if (!teachrId || typeof teachrId !== 'number') {
          console.warn("getUrssafTdae: teachrId invalide ou manquant", teachrId);
          return;
        }
        const response = await Teachr_Repository.getUrssafTdae(teachrId)
        
        dispatch({ type: GET_URSSAF_TDAE, value: response });
      } catch (error: any) {
        console.warn("Erreur lors de la récupération de l'URSSAF TDAE :", error);
        // Ne pas propager l'erreur pour éviter de bloquer l'interface
        // L'erreur est déjà loggée ci-dessus
      }
    };
};
  
export const userSetInfoSiret = (value : any): ActionInterface => {
    return {
        type: USER_SET_INFO_SIRET,
        value: value,
    };
};
export const userUnSetInfoSiret = (): ActionInterface => {
    return {
        type: USER_SET_INFO_SIRET,
        value: null,
    };
};

export const userSetCooperativeForm = (value: any): ActionInterface => {
    return {
        type: USER_SET_COOPERATIVE_FORM,
        value,
    };
};

export const userUnSetCooperativeForm = (): ActionInterface => {
    return {
        type: USER_SET_COOPERATIVE_FORM,
        value: null,
    };
};

export const userSetSapForm = (value: any): ActionInterface => {
    return {
        type: USER_SET_SAP_FORM,
        value,
    };
};

export const userUnSetSapForm = (): ActionInterface => {
    return {
        type: USER_SET_SAP_FORM,
        value: null,
    };
};
